import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';

export function isSimulationEnabled(): boolean {
  return FeatureFlags.questronEnabled;
}
